import editTenderMixin from 'mixins/editTenderMixin.js'
import functionMixin from 'mixins/functionMixin'
import functionRandom from 'mixins/functionRandom'
import { getCombinedRules, getAdditionalFieldLotRules } from 'components/tenderCreation/rules.js'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

const lotTemplate = {
  lotId: 0,
  lotNumber: 1,
  lotSubject: '',
  quantity: 0,
  minimalSubmitQuantity: null,
  bidPriceLimit: null,
  measuringUnit: null,
  startAmount: 0,
  bidStep: 0,
  description: '',
  applicationRowsKey: [],
  discounts: null,
  addressId: null,
}

export default {
  mixins: [editTenderMixin, functionMixin, functionRandom],
  data() {
    return {
      that: this,
      headers: [],
      old: [],
      imported: false,
    }
  },
  methods: {
    createLotTemplate(lotNumber = null) {
      const newLot = this.$_.cloneDeep(lotTemplate)
      newLot.lotNumber = lotNumber || this.maxLotNumber + 1
      newLot.guid = this.$_createGuid()
      return newLot
    },
    async sendEventRules(validate) {
      //формируем правила внутри самого компонента
      let newRules = getCombinedRules(this, ['TenderLots'])

      if (!this.isGroupLotsEnabled) {
        this.tender.lots?.forEach((fieldItem, lotIndex) => {
          this.additionalFieldsLots?.forEach((field) => {
            newRules = {...newRules, ...getAdditionalFieldLotRules(this, lotIndex, field, false)}
          })
        })
      }

      this.$emit('update:rules', newRules)
      if (validate) {
        this.$emit('startValidate')
      }
    },
    async afterSendTender(tender) {
      if (this.isUseAdditionalFields) {
        tender.lots.forEach((lot, lotIndex) => {
          lot.additional_fields = this.tender.lots[lotIndex].additional_fields
        })
        if (this.isGroupLotsEnabled && this.$_initializeLotGroups) {
          this.$_initializeLotGroups(tender, true)
        }
        this.mixin_bindAdditionalFields(tender)
        this.additionalFieldsLotsNew = []
      }
    },
    checkValid() {
      return new Promise((resolve) => {
        if (!this.$parent.validate) { return }
        this.$parent.validate((valid) => {
          return resolve(valid)
        })
      })
    },
    async updateAdditionalColumns(value) {
      if (value) {
        this.additionalFieldsLots = value
        this.$nextTick(async () => {
          await this.createLotHeaders()
          await this.createLotHeaders() // Костылище. Но, на задачу уже много времени ушло
          // суть баги: при удалении доп. поля удаляются все заполненные данные
        })
      }
    },
    updateRulesAfterChangeLots() {
      /** костыль. Т.к. правила затирают существующие по ключу, но, не удаляют */
      const stepRules = this.$parent?.$parent?.stepRules || {}
      Object.keys(stepRules).forEach((stepRuleKey) => {
        if (stepRuleKey.includes('lots[')) {
          delete stepRules[stepRuleKey]
        }
      })
      /** костыль. Т.к. правила затирают существующие по ключу, но, не удаляют */

      this.createLotHeaders()
    },
    async updateCart(data, newImport) {
      if (!data) {
        return
      }
      if (newImport) {
        this.imported = true
        await this.getAdditionalData()
        this.$sinfo('updateCart', {...this.tenderMutable})
        this.tenderMutable = data
        await this.createLotHeaders()
        this.imported = false
        return
      } else if (data?.length) {
        this.positions = data
        this.initPageData()
        this.imported = true
      }
    },
    /**
     * Стандартное наименование метода для вызова при переходе между шагами
     */
    async beforeSendTender() {
      /*const updatedTender = this.$_.cloneDeep(this.tenderMutable)

      this.positions = this.positions?.map(el => {
        el.description = el.description?.trim() || ''
        return el
      }) || []
      updatedTender.lots = this.positions*/
      if (this.isAuction && this.tender.lots?.some(lot => lot.bidStep || lot.startAmount)) {
        await api.fillAuctionData(this.tender.tenderId, {
          bidStepType: this.tender.bidStepType ? 'ABSOLUTE' : 'PERCENT',
          lots: this.tender.lots?.map(lot => ({
            lotId: lot.lotId,
            startAmount: lot.startAmount,
            bidStep: lot.bidStep,
          }))
        })
      }
      
      /*this.$emit('update:tender', updatedTender)*/
    },
    /**
     * Вызывается перед переходом на следующий шаг
     */
    beforeNextStep() {
      if (!this.$can('use', 'allowLotDuplication')) {
        const hasDuplicates = this.tender.lots?.some((item, index) => {
          return this.tender.lots.findIndex((innerItem, innerIndex) => {
            return innerIndex !== index && innerItem.lotSubject === item.lotSubject && innerItem.measuringUnit === item.measuringUnit
          }) !== -1
        })
        if (hasDuplicates) {
          this.$notice.warning({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Validate.DublicateLotNameAndUnit'),
            dangerouslyUseHTMLString: true,
            duration: 10,
            progress: true,
          })
          return false
        }
      }
      return true
    },
    async createLotHeaders() {
      const is_multistaged = this.tender?.biddingType?.isMultistage

      let headers = [
        { text: this.$t('Catalog.Position'), required: true, value: 'lotSubject', sortable: false, minWidth: '150px' },
        { text: this.$t('Tenders.AdditionalDescription'), value: 'description', sortable: false, width: '20%', minWidth: '250px' },
        { text: this.$t('Catalog.Amount'), required: true, value: 'quantity', sortable: false, width: '7%', minWidth: '100px' },
        { text: this.$t('Tenders.UnitOfMeasurement'), required: true, value: 'measuringUnit', sortable: false, width: '7%', minWidth: '100px' }
      ]

      if (!this.tender.biddingType?.tenderingForPercentage && (!this.tender.biddingType?.biddingTypeId || this.tender.biddingType?.initialRateAvailable) && !is_multistaged && (this.$can('set', 'BudgetType', 'AMOUNT') || this.$can('set', 'BudgetType', 'AMOUNT_AND_MINIMAL_STEP'))) {
        headers.push(
          { text: this.$t('Tenders.StartingPrice'), value: 'startAmount', sortable: false, width: '10%' },
          { text: this.$t('Tenders.Price'), value: 'summ', sortable: false, width: '12%', cellClass: 'secondary__green_chosen' }
        )
        headers[headers.length - 1].cellClass = 'secondary__green_chosen'
      }

      if ((!this.tender.biddingType?.biddingTypeId || this.tender.biddingType?.bidStepAvailable) && !is_multistaged && (this.$can('set', 'BudgetType', 'MINIMAL_STEP') || this.$can('set', 'BudgetType', 'AMOUNT_AND_MINIMAL_STEP'))) {
        headers.splice(-1, 0, { text: this.$t('Tenders.RatesStep'), value: 'bidStep', sortable: false, width: '9%' })
      }

      if (this.tender.biddingType?.hasLimitBidPrice) {
        headers.push(
          { text: this.$t('Tenders.MinPrice'), value: 'bidPriceLimit', sortable: false, width: '10%' },
        )
      }

      if (this.$can('set', 'deliveryAddress')) {
        headers.splice(-1, 0, { text: this.$t('Catalog.DeliveryAddress'), value: 'addressId', sortable: false, width: '12%', cellClass: this.isAuction ? 'secondary__green_chosen' : '' })
      }

      if (this.tender.biddingType?.tenderingForPercentage) {
        headers.splice(-1, 0, { text: `${this.$t('Tenders.StartingBid')}`, value: 'startAmount', sortable: false, width: '10%' })
        const bidStepHeader = headers.find(i => i.value === 'bidStep')
        if (bidStepHeader) {
          bidStepHeader.text = this.$t('Tenders.IncreaseStep')
        }
      }

      if (this.tender.biddingType?.minimalQuantity) {
        headers.push({ text: this.$t('Tenders.MinimalQuantity'), value: 'minimalSubmitQuantity', sortable: false, width: '110px' })
      }

      if (this.tender.biddingType?.saleWithDiscount) {
        headers.push({ text: this.$t('Catalog.Price'), value: 'discounts', sortable: false, width: '225px' })
        const indexToDelete = headers.findIndex(i => i.value === 'startAmount')
        if (indexToDelete !== -1) {
          headers.splice(indexToDelete, 1)
        }
      }

      const titleSort = ['lotSubject', 'description', 'quantity', 'measuringUnit', 'startAmount', 'bidPriceLimit', 'bidStep']

      if (this.tender.biddingType?.saleWithDiscount) {
        titleSort.push('minimalSubmitQuantity', 'discounts', 'summ')
      }

      // Если указан порядок, то сортируем колонки
      if (titleSort?.length) {
        titleSort.forEach((item, index) => {
          const header = headers.find(i => i.value === item)
          if (header) {
            header.order = index + 1
          }
        })
        let lastOrder = titleSort.length || 1
        headers.forEach(header => {
          if (!header.order) {
            header.order = lastOrder + 1
            lastOrder += 1
          }
        })
        headers.sort((a, b) => a.order - b.order)
      }
      if (this.isUseAdditionalFields && this.additionalFieldsLots?.length) {
        headers = await this.addedAdditionalFielHeaders(headers)
      }
      headers.push({ value: 'menuWithAdditionalField', sortable: false, width: '10px', order: 1024, fixed: true })

      if (!this.tender?.createdByExternalApi) {
        headers.unshift({text: '', value: 'data-table-select', width: '40px', filterable: false })
      }
      this.$set(this, 'headers', headers)

      this.$nextTick(() => {
        this.sendEventRules()
      })
    },
    async addedAdditionalFielHeaders(headers) {
      // заносим доп поля в список
      if (this.isUseAdditionalFields) {
        headers = await this.$_addAdditionalFieldsToHeaders(headers, this.additionalFieldsLots, true, 'additional_fields.')
      }

      if (!this.tender?.lots?.length) {
        return headers
      }
      const newPositions = [...this.positions]
      newPositions.forEach((lot, index) => {
        newPositions[index] = this.mixin_setAdditionalFieldsToLot(lot)
      })
      this.positions = newPositions

      return headers
    },
    async getAdditionalData() {
      if (this.isUseAdditionalFields) {
        await this.$store.dispatch('setAdditionalFieldsTypes')
        if (this.tender.tenderId) {
          await this.$store.dispatch('editTenderStore/getAdditionalFieldsByEntity', {tenderId: this.tender.tenderId})
          await this.$store.dispatch('editTenderStore/getAdditionalFieldsByBindingConditions', {
            classificationCode: this.tender?.classificationCode,
            biddingTypeId: this.tender?.biddingType?.biddingTypeId,
          })
        }
      }
    },
    async initPageData() {
      this.imported = false
      this.old = this.$_.cloneDeep(this.tender?.lots)

      await this.getAdditionalData()

      await this.createLotHeaders()
    }
  },
  computed: {
    isUseAdditionalFields() {
      return this.$can('use', 'availableAdditionalFields') && !this.isGroupLotsEnabled
    },
    useImportXLS() {
      if (this.tender?.createdByExternalApi || this.tender?.biddingType?.onlyOneLotPerTender) {
        return false
      }
      return this.tender || this.$can('add', 'appResources')
    },
    maxLotNumber() {
      if (!this.positions?.length) {
        return 0
      }
      return this.positions?.reduce((max, obj) => obj.lotNumber > max ? obj.lotNumber : max, this.positions[0]?.lotNumber || 0) || 0
    },
    tenderMutable: {
      get() {
        return this.tender
      },
      set(newValue) {
        this.$emit('update:tender', newValue)
      }
    },
    positions: {
      get() {
        return this.$_.cloneDeep(this.tender?.lots)?.sort((a,b) => a.lotNumber - b.lotNumber)
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.tender)
        result.lots = newValue
        const oldCount = this.$_.cloneDeep(this.tender?.lots || []).length
        const newCount = this.$_.cloneDeep(result?.lots || []).length

        this.$emit('update:tender', result)
        this.$nextTick(async () => {
          await this.sendEventRules(oldCount !== newCount)
        })
      }
    },
  },
  props: {
    tender: {
      type: Object
    },
    rules: {
      type: Object
    }
  },
  async created() {
    if ((!this.topMeasurements || !this.topMeasurements.length) && this.tender) {
      this.$store.dispatch('setTopMeasurements')
    }
    this.$root.$on('updateAdditionalFieldsEntity', this.createLotHeaders)
    await this.initPageData()
  },
  beforeDestroy() {
    this.$root.$off('updateAdditionalFieldsEntity', this.createLotHeaders)
    this.beforeSendTender()
  },
}